/**
 * Emoji Registry HTTP paths relative to `API_BASE_URL` (RTK `baseApi` prefixes `/api`).
 * Mirrors the routes mounted in n450s_backend/server.ts.
 */
const enc = encodeURIComponent;

/** Public surface — selector state + claim signature. */
export const emojiPaths = {
  selector: "/emoji/selector",
  claim: "/emoji/claim",
} as const;

/** Admin registry tooling (`/api/v2/emoji/admin/...`). */
export const emojiAdminPaths = {
  registry: "/v2/emoji/admin/registry",
  registryItem: (id: string) => `/v2/emoji/admin/registry/${enc(id)}`,
  registryReserve: (id: string) => `/v2/emoji/admin/registry/${enc(id)}/reserve`,
  registryRelease: (id: string) => `/v2/emoji/admin/registry/${enc(id)}/release`,
  reservationsSync: "/v2/emoji/admin/reservations/sync",
  stats: "/v2/emoji/admin/stats",
  candidates: "/v2/emoji/admin/candidates",
  candidatesPromote: "/v2/emoji/admin/candidates/promote",
  candidatesDismiss: "/v2/emoji/admin/candidates/dismiss",
} as const;
